import { useState, useEffect, useRef } from 'react';
import { ActionButton } from '../../common/Buttons/Buttons';
import { Header } from '../../common/Header/Header.jsx';
import {
  PrimaryAsistancePlanTable,
} from '../../common/Tables/Tables';
import {
  PAPTableHeader,
} from '../../../assets/helpers/tables';
import { notify } from '../../../assets/helpers/toast';
import { salesRoles } from '../../../assets/helpers/roles.js';
import { saleChannelService } from '../../../services/saleChannelService.js';
import { papService } from '../../../services/papService';
import { useHistory, useParams } from "react-router-dom"
import {
  FilterDatePicker,
  SearchInput,
  SelectPerPage,
  Select
} from '../../common/Forms/Input/Input';
import moment from 'moment';
import { ExportableOtpModules } from '../../../assets/helpers/options.js';

import authService from '../../../services/authService.js';
import { OtpModal } from '../../common/Modals/Modals.jsx';

const itemsPerpage = [10, 25, 50, 100, 500];
export const PrimaryAsistenciaPlan = () => {
  const tableRef = useRef(null);
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);

  const { month, year, saleChannelId } = useParams();
  const [saleChannel, setSaleChannel] = useState(saleChannelId);
  const [salesChannelOptions, setSalesChannelOptions] = useState([]);
  const [otpCode, setOtpCode] = useState('');
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [isLoadingEmail, setIsLoadingEmail] = useState(false);


  const [membershipsDatatable, setMembershipsDatatable] = useState({
    limit: itemsPerpage[2],
    offset: 0, //Elementos que ya pasaron la pagina
    data: [],
    count: 0, //Cantidad de elementos
    page: 1,
    dateFrom: '',
    dateTo: '',
    isLoading: false,
    searchParam: '',
  });

  const redirectToPAPDetail = (membershipId) => {
    history.push(`/afiliations/old-memberships/client/${membershipId?.clientId?._id}`);
  }

  const setFirstPage = () => {
    setMembershipsDatatable((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
      };
    });
  };

  const handleSinceDateChange = (e) => {
    if (e > dateTo && dateTo) {
      notify('Ingrese una fecha en un rago valido ', 'info');
    } else {
      setFirstPage();
      setDateFrom(e);
    }
  };

  const handleUntilDateChange = (e) => {
    if (e < dateFrom && dateFrom) {
      notify('Ingrese una fecha en un rago valido ', 'info');
    } else {
      setFirstPage();
      setDateTo(e);
    }
  };

  const formatSellers = (arr) => {
    let data = [];
    for (let i = 0; i < arr?.length; i++) {
      data.push({
        name: `${arr[i]?.firstName} ${arr[i]?.lastName}`,
        _id: arr[i]?._id,
      });
    }
    data = data
      .filter(
        (item, index, self) =>
          self.findIndex((t) => t._id === item._id) === index
      )
      .sort((a, b) => a.name.localeCompare(b.name));
    return data;
  };

  const selectitemsPerpage = (event) => {
    setMembershipsDatatable((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
        limit: parseInt(event.target.value),
      };
    });
  };

  const handlePageChange = (event, value) => {
    setMembershipsDatatable((prevState) => {
      return {
        ...prevState,
        page: value,
        offset: (value - 1) * membershipsDatatable?.limit,
      };
    });
  };

  const handleSearchChange = (event) => {
    setMembershipsDatatable((prevState) => {
      return {
        ...prevState,
        searchParam: event?.target?.value,
        page: 1,
        offset: 0,
        data: false,
      };
    });
  };


  useEffect(() => {
    getMemberships(month, year);
  }, []);

  useEffect(() => {
    getMemberships();
    getSalesChannel()
    // getMembershipsByStatus();
  }, [
    membershipsDatatable?.page,
    membershipsDatatable?.offset,
    membershipsDatatable?.limit,
    membershipsDatatable?.type,
    dateFrom,
    dateTo,
  ]);



  const getMemberships = (month, year) => {

    if (month && year) {
      let from = moment().month(month - 1).year(year).startOf('month').toDate()
      let to = moment().month(month - 1).year(year).endOf('month').toDate()
      setDateFrom(from)
      setDateTo(to)
    }

    let params = {
      limit: membershipsDatatable?.limit,
      offset: membershipsDatatable?.offset,
      channel: saleChannel || '',
      dateFrom: dateFrom
        ? moment(dateFrom).format('YYYY-MM-DD')
        : window.location.pathname.includes('pendiente-de-aprobacion')
          ? moment().subtract(3, 'months').format('YYYY-MM-DD')
          : moment().add(1, 'day').format('YYYY-MM-DD'),
      dateTo: dateTo
        ? moment(dateTo).format('YYYY-MM-DD')
        : window.location.pathname.includes('pendiente-de-aprobacion')
          ? moment().format('YYYY-MM-DD')
          : moment().add(2, 'days').format('YYYY-MM-DD'),
    };


    setIsLoading(true);

    papService
      .listServices(params)
      .then((response) => {
        if (response.status === 200) {
          setMembershipsDatatable((prevState) => {
            return {
              ...prevState,
              data: response.data?.memberships || [],
              isLoading: false,
              count: response.data?.total
            };
          });
          setIsLoading(false);
        } else {
          notify(`${response.message}` || 'error', 'error');
          setMembershipsDatatable((prevState) => {
            return {
              ...prevState,
              isLoading: false,
            };
          });
          setIsLoading(false);
        }
      })
      .catch(() => {
        setIsLoading(false);
      });

    return true;
  };

  const showOtp = () => {
    if (!otpCode && !isLoading) {
      authService
        .sendOtp({ module: ExportableOtpModules.MEMBERSHIP_EXPORTABLE })
        .then((response) => {
          if ([200, 201].includes(response?.status)) {
            notify('Ingrese el código OTP enviado a su correo', 'Success');
            setShowOtpModal(true);
          } else {
            notify(`${response.message}`, 'error');
          }
        })
        .catch((error) => { });
    }
  };

  const exportAffiliationTable = async () => {
    let params = {
      limit: membershipsDatatable?.limit,
      offset: membershipsDatatable?.offset,
      channel: saleChannel || '',
      dateFrom: dateFrom
        ? moment(dateFrom).format('YYYY-MM-DD')
        : moment().subtract(1, 'month').format('YYYY-MM-DD'),
      dateTo: dateTo
        ? moment(dateTo).format('YYYY-MM-DD')
        : moment().format('YYYY-MM-DD'),
      byMail: true,
    };

    if (membershipsDatatable?.searchParam) {
      params.searchParam = membershipsDatatable?.searchParam;
    }

    if (
      ![
        salesRoles?.SALES_ADMIN,
        salesRoles?.SALES_ADMIN_AUX,
        salesRoles?.SALES_DEVELOPER,
        salesRoles?.SALES_SUPERVISOR,
      ].includes(authService?.getUserType()) &&
      params.byMail === true
    ) {
      params.otp = otpCode;
    }

    if (!isLoadingEmail) {
      notify(
        `Solicitud de exportable realizada, espere a recibir un correo con el archivo correspondiente`,
        'info'
      );

      papService
        .listServices(params)
        .then((response) => {
          if (response.status === 200) {
            setIsLoadingEmail(false);
            setOtpCode('');
            setShowOtpModal(false);
          } else {
            notify(`${response.message}` || 'error', 'error');
            setIsLoadingEmail(false);
          }
        })
        .catch(() => {
          setIsLoadingEmail(false);
        });
      return true;
    }
  };

  const getSalesChannel = () => {
    saleChannelService
      .getSalesChannel()
      .then((response) => {
        if ([200, 201].includes(response?.status)) {
          setSalesChannelOptions([{ _id: "", name: "" }, ...response?.data?.saleChannels]);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => { });
  };

  const selectSaleChannel = (e) => {
    const { value } = e?.target;
    setSaleChannel(value);
  }

  return (
    <>
      <Header />
      {/* <LoadSpinner show={isLoading} /> */}
      {showOtpModal && (
        <OtpModal
          show={showOtpModal}
          handleClose={() => {
            setShowOtpModal(false);
            setOtpCode('');
          }}
          code={otpCode}
          setCode={setOtpCode}
          handleExport={exportAffiliationTable}
        />
      )}
      <div className="service-with-container container">
        <div className="buttons-container">
          <h1 className="title-component">
            Plan de Asistencia Primaria {membershipsDatatable?.count}
          </h1>
          <div className="buttons-container">
            <ActionButton
              label={'Comisiones'}
              action={() => history.push('/dashboard/pap-affiliated/commissions')}
            />
            {![
              salesRoles?.SALES_HUNTER,
              salesRoles?.SALES_COUNTER,
              salesRoles?.SALES_ADMIN_AUX,
              salesRoles?.SALES_KEY_ACCOUNTS,
            ].includes(authService?.getUserType()) && (
                <ActionButton
                  label={'Exportar'}
                  action={() => {
                    if (
                      ![
                        salesRoles?.SALES_ADMIN,
                        salesRoles?.SALES_ADMIN_AUX,
                        salesRoles?.SALES_DEVELOPER,
                        salesRoles?.SALES_SUPERVISOR,
                      ].includes(authService?.getUserType())
                    ) {
                      showOtp();
                    } else {
                      exportAffiliationTable();
                    }
                  }}
                />
              )}
          </div>
        </div>
        <div className="breadcrumb-container">
          <div></div>
          <div className="exportables-buttons-container">
            <div style={{ width: '100%' }} className="row">
              <div className="col-12 col-md-2" style={{ marginTop: '30px' }}>
                <SearchInput
                  placeholder={
                    'Nombre o Apellido, Teléfono, Cédula ,Referencia o Placa'
                  }
                  searchAction={getMemberships}
                  value={membershipsDatatable?.searchParam}
                  onChange={handleSearchChange}
                  width="50px"
                />
              </div>
              <>
                <FilterDatePicker
                  bootstrap={'col-12 col-md-2'}
                  label={'Desde'}
                  type={'date'}
                  name={'dateFrom'}
                  placeholder={''}
                  onChange={handleSinceDateChange}
                  value={dateFrom}
                  disabled={membershipsDatatable?.isLoading}
                />
                <FilterDatePicker
                  bootstrap={'col-12 col-md-2'}
                  label={'Hasta'}
                  type={'date'}
                  name={'dateTo'}
                  placeholder={''}
                  onChange={handleUntilDateChange}
                  value={dateTo}
                  disabled={membershipsDatatable?.isLoading}
                />
                <div className="col-12 col-md-2" style={{ marginTop: '10px' }}>
                  <Select
                    options={salesChannelOptions}
                    label={'Canal'}
                    value={saleChannel}
                    onChange={selectSaleChannel}
                  />
                </div>
              </>
              <divl style={{
                marginTop: '24px',
                marginLeft: 'auto',
                width: '450px',
                display: 'flex',
                justifyContent: 'flex-end',
                textAlign: 'center',
                alignItems: 'center',
              }}>
                <SelectPerPage
                  label={'Registros por página'}
                  options={itemsPerpage}
                  value={membershipsDatatable?.limit}
                  onChange={selectitemsPerpage}
                />
              </divl>
            </div>
          </div>
        </div>
        <PrimaryAsistancePlanTable
          header={PAPTableHeader}
          data={membershipsDatatable}
          redirectToPAPDetail={redirectToPAPDetail}
          handlePageChange={handlePageChange}
          tableRef={tableRef}
          dateFrom={dateFrom}
          dateTo={dateTo}
        />
      </div>
    </>
  );
};
